import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material';
import { CssBaseline } from '@mui/material';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './css/styleguide.css';
import ProtectedRoute from './components/ProtectedRoute';
import { UserProvider } from './context/UserContext';

// Direct imports for all pages
import LogPage from './pages/LogPage';
import CommunityPage from './pages/CommunityPage';
import MyJoyNetPage from './pages/MyJoyNetPage';
import ProfilePage from './pages/ProfilePage';
import OtherUserProfilePage from './pages/OtherUserProfilePage';
import MessagesPage from './pages/MessagesPage';
import FriendsPage from './pages/FriendsPage';
import OneMoreStep from './pages/OneMoreStep';
import SignUpPage from './pages/SignUpPage';
import OnboardingPage from './pages/OnboardingPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

const theme = createTheme({
  palette: {
    mode: 'light',
  },
});

/* This is the main App component. It is used to define the pages for the website. */

export default function App() {
  return (
    <UserProvider>   
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={
              <ProtectedRoute>
                <CommunityPage />
              </ProtectedRoute>
            } />
            <Route path="/messages" element={
              <ProtectedRoute>
                <MessagesPage />
              </ProtectedRoute>
            } />
            <Route path="/friends" element={
              <ProtectedRoute>
                <FriendsPage />
              </ProtectedRoute>
            } />
            <Route path="/myjoynet" element={
              <ProtectedRoute>
                <MyJoyNetPage />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            } />
            <Route path="/profile/:userId" element={
              <ProtectedRoute>
                <OtherUserProfilePage />
              </ProtectedRoute>
            } />
            <Route path="/onboarding" element={
              <ProtectedRoute>
                <OnboardingPage />
              </ProtectedRoute>
            } />
            <Route path="/justonemorestep" element={
              <ProtectedRoute>
                <OneMoreStep />
              </ProtectedRoute>
            } />

            {/* AUTH NOT REQUIRED */}
            <Route path="/login" element={<LogPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </UserProvider>
  );
}
